export const getDarkMediaMatch = () => window.matchMedia('(prefers-color-scheme: dark)');
